import React, { useCallback, memo } from 'react';
import { Button } from '@core/components/Button';

interface SimplePaginationProps {
  total: number;
  page: number;
  onPage?(page: number): void;
  maxPage?: number;
}

export const SimplePagination = memo((props: SimplePaginationProps) => {
  const { total, page, onPage, maxPage = 5 } = props;

  const getPageRange = useCallback(() => {
    const range = [];
    const start = Math.max(1, page - Math.floor(maxPage / 2));
    const end = Math.min(total, start + maxPage - 1);
    for (let i = start; i <= end; i++) {
      range.push(i);
    }
    return range;
  }, [page, total, maxPage]);

  const isActive = useCallback((input: number) => input === page, [page]);

  return (
    <>
      {getPageRange().map((page, i) => {
        return (
          <Button
            key={i}
            intent={isActive(page) ? 'primary' : 'light'}
            style={{ borderRadius: 20, padding: 0, width: 30, height: 30, marginRight: 5 }}
            type="button"
            onClick={() => onPage && onPage(page)}
          >
            <span>{page}</span>
          </Button>
        );
      })}
    </>
  );
});
